var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.2,
    height: 18.2,
    viewBox: "0 0 18.2 18.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_57_page-break_18px",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Icon_metro-page-break",
    "data-name": "Icon metro-page-break",
    d: "M2.571,10.928h2.25v1.125H2.571Zm3.375,0H9.321v1.125H5.946Zm4.5,0H12.7v1.125h-2.25Zm3.375,0H17.2v1.125H13.821Zm4.5,0h2.25v1.125h-2.25Zm-.281-9L18.321,9.8H4.821L5.1,1.928h.563l.281,6.75H17.2l.281-6.75ZM5.1,19.928l-.281-6.75h13.5l-.281,6.75h-.562L17.2,14.3H5.946l-.281,5.625Z",
    transform: "translate(-2.571 -1.928)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/Break.7ce5412892db7c28be52f0e276a027ce.svg";
export { ForwardRef as ReactComponent };